import {useLazyFetchBase64Binary} from 'hooks/api/useFetchBase64Binary'

export const useLazyFetchDocumentSharedTemplatePdf = (templateId: string) => {
  const path = `/api/document_shared_templates/${templateId}.pdf`
  return useLazyFetchBase64Binary(path, undefined)
}
